export default {
  state: {
    // 初始化企业信息
    uid: "",
    name: "",
    state: "",
  },
  mutations: {
    // 处理状态
    setEnterprise: (state: any, enterprise: any) => {
      state.uid = enterprise.uid;
      state.name = enterprise.name;
      state.state = enterprise.state;
    },

    // 清空数据
    resetState: (state: any) => {
      state.uid = "";
      state.name = "";
      state.state = "";
    },
  },
};
